import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsxRuntime classic */
/** @jsx createSICLElement */
import React from 'react';
import { createSICLElement } from '../createSICLElement';
import { SICLBaseButton } from './SICLBaseButton';
export var siclMakeButtonRenderLink = function siclMakeButtonRenderLink(onClick, buttonRef) {
  return function (_ref) {
    var children = _ref.children,
      disabled = _ref.disabled,
      ariaLabel = _ref.ariaLabel;
    return createSICLElement("button", {
      "aria-label": ariaLabel,
      type: "button",
      disabled: disabled,
      onClick: onClick,
      ref: buttonRef
    }, children);
  };
};
export var SICLButton = React.forwardRef(function (props, buttonRef) {
  // The destructing operation extracts the onClick away from the baseButtonProps so
  // That it can be passed down to SICLBaseButton with the correct and allowed properties.
  // So be careful when modifying the destructing logic below.
  var onClick = props.onClick,
    baseButtonProps = _objectWithoutProperties(props, ["onClick"]);
  var renderLink = siclMakeButtonRenderLink(onClick, buttonRef);
  return createSICLElement(SICLBaseButton, Object.assign({
    renderLink: renderLink
  }, baseButtonProps));
});